module.exports = __webpack_public_path__ + "img/selections-2.webp";